import { render, staticRenderFns } from "./EkbModal.vue?vue&type=template&id=2bb76112&"
import script from "./EkbModal.vue?vue&type=script&lang=js&"
export * from "./EkbModal.vue?vue&type=script&lang=js&"
import style0 from "./EkbModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports